import React from 'react';
import InlineButton from 'components/generic/InlineButton/InlineButton';
import { useTranslation } from 'react-i18next';
import { Signup } from 'autogen/translation-keys/trans-website-shared';
import UAEventTracking from 'modules/tracking/UAEventTracking';
import useSignUpNudgeQuickView from 'components/clubMatas/SignUpNudgeQuickView/shared/hooks/useSignUpNudgeQuickView';

export default function DeliveryIndicator() {
    const [, toggle] = useSignUpNudgeQuickView();
    const { t } = useTranslation();

    return (
        <InlineButton
            onClick={() => {
                toggle({ isOpen: true });
                UAEventTracking({
                    eventCategory: 'productPage',
                    eventAction: 'signUp',
                    eventLabel: t(Signup)
                });
            }}
        >
            {t(Signup)}
        </InlineButton>
    );
}
